import { getStrings, homeShellString } from "../i18n/strings";
import { getToolsStrings } from "../i18n/toolsStrings";
import { TOOL_KEYS, toolHref } from "../config/toolRegistry";
import { ToolIcon } from "./ToolIcon";

type Strings = ReturnType<typeof getStrings>;

// The full 9-tool SEO matrix (spec §四) — every tool NetRiskScan has gets a real <a href> straight
// off the home page, not just the four that used to get cards here. Deliberately imports only the
// icon/string/registry data below, never a tool page's own component: this section must not pull any
// tool page's logic into the home bundle (spec §十八).
export function HomeMoreTools({ strings, lang, defaultUrlCode }: { strings: Strings; lang: string; defaultUrlCode: string }) {
  const t = <K extends Parameters<typeof homeShellString>[1]>(key: K) => homeShellString(strings, key);
  const toolStrings = getToolsStrings(lang);

  return (
    <nav className="home-more" aria-labelledby="home-more-title">
      <h2 id="home-more-title" className="home-section-title">{t("homeMoreToolsTitle")}</h2>
      <div className="home-more__grid">
        {TOOL_KEYS.map((key) => {
          const tool = toolStrings.tools[key];
          const href = toolHref(key, lang, defaultUrlCode);
          return (
            <a className="home-more-card" href={href} key={key}>
              <span className="home-more-card__icon" aria-hidden="true"><ToolIcon tool={key} /></span>
              <span className="home-more-card__title">{tool.title}</span>
              <span className="home-more-card__text">{tool.description}</span>
              {/* An arrow rather than a "go" label: homeOpenTool is not translated for every enabled
                  locale, and a half-translated CTA on an otherwise localized card is exactly the
                  English-leak spec §十三 rules out. The card itself is the link. */}
              <span className="home-more-card__go" aria-hidden="true">→</span>
            </a>
          );
        })}
      </div>
    </nav>
  );
}
